angular.module('elfium').controller('dashboardController', ['$scope', 'elfiumToastrService', 'dashboardTotalService', 'dashboardSumService',
    function ($scope, elfiumToastrService, dashboardTotalService, dashboardSumService) {
        var that = this;
        $scope.dashboardFilter = {};
        $scope.businessCaseSums = {
            closed: {},
            toClose: {},
            offers: {}
        };
        that.getBusinessCaseCounterDto = function () {
            dashboardTotalService.getBusinessCaseCounterDto($scope.dashboardFilter).then(function (businessCaseCounter) {
                $scope.businessCaseCounter = businessCaseCounter;
            }, elfiumToastrService.error);
        };
        that.getBusinessCaseSums = function () {
            dashboardSumService.getBusinessCaseSums($scope.dashboardFilter).then(function (businessCaseSums) {
                $scope.businessCaseSums = businessCaseSums;
            });
        };        
        

        $scope.gaugeOptions = {
            value: 51,
            upperLimit: 150,
            lowerLimit: 0,
            valueUnit: "%",
            precision: 1,
            ranges: [{
                min: 0,
                max: 74,
                color: '#C50200 '
            }, {
                min: 75,
                max: 99,
                color: '#FDC702'
            }, {
                min: 100,
                max: 150,
                color: '#8DCA2F'
            }]
        }
    }
]); 


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardController.ts